import { render, staticRenderFns } from "./TarjetaComercioSeleccionable.vue?vue&type=template&id=321ba334&scoped=true&"
import script from "./TarjetaComercioSeleccionable.vue?vue&type=script&lang=js&"
export * from "./TarjetaComercioSeleccionable.vue?vue&type=script&lang=js&"
import style0 from "./TarjetaComercioSeleccionable.vue?vue&type=style&index=0&id=321ba334&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321ba334",
  null
  
)

export default component.exports